module.exports = __webpack_public_path__ + "img/main-logo.2483a734.png";